import WINDOW from "../../../utils/window";
import startRaf from "../../animate/start-raf";
import stopRaf from "../../animate/stop-raf";

/**
 * On window visibility change
 */
const onVisibilityChange = () => {
  if (document.visibilityState === "hidden") {
    WINDOW.set("hidden", true);

    stopRaf();
  } else {
    // const last = /** @type {Number} */ (WINDOW.get("raf-last"));

    WINDOW.set("hidden", false);

    // WINDOW.set("raf-difference", performance.now() - last);
    startRaf();
  }
};

export default onVisibilityChange;
